var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaypart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.79 16.41",
    height: "1.2em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .daypart__cls {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2.62px;\n      }\n      .daypart__cls-2 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_149",
    "data-name": "Groupe 149"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_60",
    "data-name": "Ligne 60",
    className: "daypart__cls",
    x1: 24.48,
    y1: 8.2,
    x2: 7.36,
    y2: 8.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_61",
    "data-name": "Ligne 61",
    className: "daypart__cls",
    x1: 24.48,
    y1: 1.55,
    x2: 7.36,
    y2: 1.55
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_62",
    "data-name": "Ligne 62",
    className: "daypart__cls",
    x1: 24.48,
    y1: 14.86,
    x2: 7.36,
    y2: 14.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "daypart__cls-2",
    d: "m1.55,3.09c.85,0,1.55-.69,1.55-1.55S2.4,0,1.55,0C.69,0,0,.69,0,1.55s.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "daypart__cls-2",
    d: "m1.55,6.66C.69,6.66,0,7.35,0,8.2s.69,1.55,1.55,1.55,1.55-.69,1.55-1.55-.69-1.55-1.55-1.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "daypart__cls-2",
    cx: 1.55,
    cy: 14.86,
    r: 1.55
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaypart);
export default __webpack_public_path__ + "static/media/daypart.407e8590ce4f6336f20444712c2bf481.svg";
export { ForwardRef as ReactComponent };